'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesPrintForm = void 0;
const $ = require("jquery");
class SalesPrintForm {
    constructor() {
        if ($('#bulletPrintForm').length) {
            this.initForm();
        }
        if ($('#trigAgreeCheck').length) {
            this.initAgreeCheckbox();
        }
    }
    // ─── フォームページ初期化 ─────────────────────────
    initForm() {
        this.initFromSession();
        this.initVehicleChange();
        this.initStepTriggers();
        this.initLinesToggle();
        this.initColorSelection();
    }
    initFromSession() {
        const data = window.printFormData;
        if (!data)
            return;
        const vehicleId = data.preselect.vehicle_id;
        const seatColorId = data.preselect.seat_color_id;
        const preselectLayout = data.preselect.layout;
        if (vehicleId) {
            this.populateSeatColors(vehicleId, seatColorId);
            this.applyLayoutRestrictions(vehicleId, preselectLayout);
        }
        this.updateStepStates();
        this.updateSidebar(this.getCurrentActiveStep());
    }
    initVehicleChange() {
        $('#trigVehicleSelect').on('change', (e) => {
            const vehicleId = parseInt(String($(e.currentTarget).val()), 10);
            // STEP2以降をリセット
            $('#bulletSeatColorSelect').val('');
            this.resetStepsFrom(3);
            if (vehicleId) {
                this.populateSeatColors(vehicleId, null);
                this.applyLayoutRestrictions(vehicleId, null);
            }
            else {
                this.clearSeatColors();
                this.applyLayoutRestrictions(null, null);
            }
            this.updateStepStates();
            this.updateSidebar(this.getCurrentActiveStep());
        });
    }
    applyLayoutRestrictions(vehicleId, preselectLayout) {
        const data = window.printFormData;
        const $labels = $('input[name="layout"]').closest('.print-form__radio-label');
        if (!vehicleId || !data) {
            $labels.show();
            return;
        }
        const vehicleData = data.vehicles[String(vehicleId)];
        const allowedLayouts = vehicleData?.allowedLayouts ?? [];
        $('input[name="layout"]').each((_, el) => {
            const $input = $(el);
            const $label = $input.closest('.print-form__radio-label');
            const val = String($input.val());
            if (allowedLayouts.includes(val)) {
                $label.show();
                if (preselectLayout === val) {
                    $input.prop('checked', true);
                }
            }
            else {
                $label.hide();
                $input.prop('checked', false);
            }
        });
    }
    initStepTriggers() {
        // STEP2: シートカラー変更
        $(document).on('change', '#bulletSeatColorSelect', () => {
            this.resetStepsFrom(3);
            this.updateStepStates();
            this.updateSidebar(this.getCurrentActiveStep());
        });
        // STEP3: レイアウト変更
        $(document).on('change', 'input[name="layout"]', () => {
            this.resetStepsFrom(4);
            this.updateStepStates();
            this.updateSidebar(this.getCurrentActiveStep());
        });
        // STEP4: プリントカラー変更
        $(document).on('change', 'input[name="print_color_id"]', () => {
            this.updateStepStates();
            this.updateSidebar(this.getCurrentActiveStep());
        });
        // STEP5: テキスト入力・フォント・行数変更
        $(document).on('change input', '#bulletText1, #bulletText2, #bulletText3, input[name="font_type"]', () => {
            this.updateStepStates();
            this.updateSidebar(this.getCurrentActiveStep());
        });
    }
    initLinesToggle() {
        $(document).on('change', 'input[name="lines"]', (e) => {
            const val = parseInt(String($(e.currentTarget).val()), 10);
            $('.bulletPrintLine2').toggle(val >= 2);
            $('.bulletPrintLine3').toggle(val >= 3);
            this.updateStepStates();
            this.updateSidebar(this.getCurrentActiveStep());
        });
        const currentVal = parseInt(String($('input[name="lines"]:checked').val() ?? '1'), 10);
        $('.bulletPrintLine2').toggle(currentVal >= 2);
        $('.bulletPrintLine3').toggle(currentVal >= 3);
    }
    initColorSelection() {
        $(document).on('change', 'input[name="print_color_id"]', (e) => {
            $('.sales-print-form__color-item').removeClass('is-selected');
            $(e.currentTarget).closest('.sales-print-form__color-item').addClass('is-selected');
        });
        // セッション復元時に is-selected を初期反映する
        const $preChecked = $('input[name="print_color_id"]:checked');
        if ($preChecked.length) {
            $preChecked.closest('.sales-print-form__color-item').addClass('is-selected');
        }
    }
    // ─── シートカラー制御 ─────────────────────────────
    populateSeatColors(vehicleId, preselectId) {
        const data = window.printFormData;
        if (!data)
            return;
        const seatColors = data.vehicles[String(vehicleId)]?.seatColors ?? [];
        const $select = $('#bulletSeatColorSelect');
        $select.empty().append('<option value="">選択してください</option>');
        seatColors.forEach((sc) => {
            const selected = preselectId && sc.id === preselectId ? ' selected' : '';
            $select.append(`<option value="${sc.id}"${selected}>${this.escapeHtml(sc.name)}</option>`);
        });
        // カードのロックを解除
        const $card2 = $('#bulletPrintCard2');
        $card2.removeClass('is-locked');
        $card2.find('select').prop('disabled', false);
    }
    clearSeatColors() {
        const $select = $('#bulletSeatColorSelect');
        $select.empty().append('<option value="">選択してください</option>');
    }
    // ─── ステップ状態管理 ─────────────────────────────
    isStep1Complete() {
        return Boolean($('#trigVehicleSelect').val());
    }
    isStep2Complete() {
        return Boolean($('#bulletSeatColorSelect').val());
    }
    isStep3Complete() {
        return $('input[name="layout"]:checked').length > 0;
    }
    isStep4Complete() {
        return $('input[name="print_color_id"]:checked').length > 0;
    }
    isStep5Complete() {
        if (!$('input[name="font_type"]:checked').length)
            return false;
        if (!$('input[name="lines"]:checked').length)
            return false;
        if (!String($('#bulletText1').val()).trim())
            return false;
        const lines = parseInt(String($('input[name="lines"]:checked').val()), 10);
        if (lines >= 2 && !String($('#bulletText2').val()).trim())
            return false;
        if (lines >= 3 && !String($('#bulletText3').val()).trim())
            return false;
        return true;
    }
    isAllComplete() {
        return (this.isStep1Complete() &&
            this.isStep2Complete() &&
            this.isStep3Complete() &&
            this.isStep4Complete() &&
            this.isStep5Complete());
    }
    getCurrentActiveStep() {
        if (!this.isStep1Complete())
            return 1;
        if (!this.isStep2Complete())
            return 2;
        if (!this.isStep3Complete())
            return 3;
        if (!this.isStep4Complete())
            return 4;
        if (!this.isStep5Complete())
            return 5;
        return 6;
    }
    updateStepStates() {
        const step1Done = this.isStep1Complete();
        const step2Done = step1Done && this.isStep2Complete();
        const step3Done = step2Done && this.isStep3Complete();
        const step4Done = step3Done && this.isStep4Complete();
        this.setCardLocked(2, !step1Done);
        this.setCardLocked(3, !step2Done);
        this.setCardLocked(4, !step3Done);
        this.setCardLocked(5, !step4Done);
        // 現在のアクティブカードに青ボーダーを付ける
        const activeStep = this.getCurrentActiveStep();
        $('.bulletPrintCard').removeClass('is-active');
        if (activeStep <= 5) {
            $(`#bulletPrintCard${activeStep}`).addClass('is-active');
        }
        // 送信ボタンの有効・無効
        const allDone = this.isAllComplete();
        $('#trigPrintSubmit').prop('disabled', !allDone);
    }
    setCardLocked(step, locked) {
        const $card = $(`#bulletPrintCard${step}`);
        if (locked) {
            $card.addClass('is-locked');
            $card.find('input, select, textarea').prop('disabled', true);
        }
        else {
            $card.removeClass('is-locked');
            $card.find('input, select, textarea').prop('disabled', false);
            // STEP2のselectは車種選択後にのみ有効化（populateSeatColorsで管理）
        }
    }
    resetStepsFrom(step) {
        for (let i = step; i <= 5; i++) {
            const $card = $(`#bulletPrintCard${i}`);
            $card.find('input[type="radio"]').prop('checked', false);
            $card.find('select').val('');
            $card.find('input[type="text"], textarea').val('');
            $card.find('.sales-print-form__color-item').removeClass('is-selected');
        }
        if (step <= 5) {
            $('.bulletPrintLine2').hide();
            $('.bulletPrintLine3').hide();
        }
    }
    // ─── サイドバー更新 ───────────────────────────────
    updateSidebar(activeStep) {
        $('#bulletPrintSteps .sales-print-steps__item').each((_, el) => {
            const step = parseInt(String($(el).data('step')), 10);
            $(el).toggleClass('is-current', step === activeStep);
        });
    }
    // ─── プレビューページ: 同意チェックボックス ───────────
    initAgreeCheckbox() {
        const $check = $('#trigAgreeCheck');
        const $btn = $('#bulletDownloadBtn');
        $check.on('change', () => {
            $btn.prop('disabled', !$check.prop('checked'));
        });
    }
    // ─── ユーティリティ ──────────────────────────────
    escapeHtml(str) {
        return str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }
}
exports.SalesPrintForm = SalesPrintForm;
exports.default = SalesPrintForm;
